// src/components/Navbar2.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar2.css';

function Navbar2() {
  return (
    <nav className="navbar2">
      <ul className="navbar2-links">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about">Our Services</Link>
        </li>
        <li>
          <Link to="/contact">Contact Us</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar2;
